import React from "react";
import searchIcon from "../images/searchIcon.png";

function Search() {
  return (
    <div className="h-[2rem] relative w-[19rem]  mt-4">
      <input
        className="h-full pl-8 accent-pink-500 w-full rounded-md bg-[#ecedef]"
        name="search"
        placeholder="Search for a friend"
      />
      <img
        className="absolute top-[.56rem] left-2"
        src={searchIcon}
        alt="searchIcon"
      />
    </div>
  );
}

export default Search;
